<template>
  <div class="widget">
    <div class="widget-title">{{ title('Summary Weekly') }}</div>
    <div class="widget-content">

      <div
        class="widget-item monthly"
        v-if="settings.value.show_goal"
      >
        Weekly Goal :
        <span class="value goal">
          {{ getData.goal | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item current"
        v-if="settings.value.show_current_total_value"
      >
        Current Total :
        <span class="value total">
          {{ getData.total | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item per-day"
        v-if="settings.value.show_needed_per_day"
      >
        Needed Per Day :
        <span class="value needed">
          {{ getData.need_per_day | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item"
        v-if="settings.value.show_working_days"
      >
        <p class="working-days">
          <span class="values working-days">
            Days :
            Working -
            <span class="value days">{{ getData.working | dayFormat }}</span>
            | Left -
            <span class="value days">{{ getData.remaining | dayFormat }}</span>
          </span>
        </p>
      </div>

    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";

export default {
  name: "SummaryWeekly",
  mixins: [widgetHelper],
  computed: {
    getData() {
      let goal = 0;
      let total = 0;

      let working = 0;
      let remaining = 0;

      let need_per_day = 0;

      const elems = this.getElemsForCalc;

      if (elems?.length) {
        for (const elem of elems) {
          goal += elem[this.useByPaymentCapacity('weekly')]?.goal || 0;

          if (this.target_type === 'Amount') {
            total += elem[this.useByPaymentCapacity('weekly')]?.[this.useNetAmount()] || 0;
          } else {
            total += (elem[this.useByPaymentCapacity('weekly')]?.[this.useNetCount] || 0);
          }

          //
          if (elem[this.useByPaymentCapacity('weekly')]?.days?.working > working) {
            working = elem[this.useByPaymentCapacity('weekly')]?.days?.working || 0;
            remaining = elem[this.useByPaymentCapacity('weekly')]?.days?.remaining || 0;
          }
        }
        need_per_day = (goal - total) / remaining;
        if (need_per_day < 0) { need_per_day = goal / working; }
      }

      return { goal, total, working, remaining, need_per_day };
    },
    ...mapGetters(["streams"]),
  },
};
</script>
